import api from "src/api/axiosInstance";
import { setcollection } from "src/store/slices/collection-slice";
import { store } from "src/store/store";

export const fetchCollections = async () => {
  try {
    const response = await api.get(`/collections`);

    // Check if the response data is an array (successful case with collections)
    if (response?.data && Array.isArray(response.data)) {
      store.dispatch(setcollection(response.data));
      return response.data;
    }
    // Check if we got the "Collections not found" response with status 1
    else if (response?.data?.message === "Collections not found" && response?.data?.status === 1) {
      store.dispatch(setcollection([])); // Set empty array in Redux store
      return [];
    }
    // Fallback case
    return [];
  } catch (error) {
    console.error("Error fetching collections:", error);
    store.dispatch(setcollection([])); // Set empty array in Redux store
    return [];
  }
};

export const fetchCollectionProduct = async (collectionID) => {
  try {
    const response = await api.post(
      `/products-filter?page=1&status=1&limit=1000`,
      { collectionIds: [collectionID] } // Sending category in the request body
    );

    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }
};

export const fetchSortedCollectionProduct = async (
  sortOption,
  collectionID,
  minPrice,
  maxPrice,
  inStock,
  outOfStock,
  categories,
) => {
  let payload = {};
  if (sortOption === "asc" || sortOption === "desc") {
    payload = { collectionIds: [collectionID], sortbyprice: sortOption };
  } else {
    payload = { collectionIds: [collectionID], sortbydate: sortOption };
  }

   // Add price range if provided
   if (minPrice) {
    payload.minPrice = parseInt(minPrice);
  }
  
  if (maxPrice) {
    payload.maxPrice = parseInt(maxPrice);
  }
  
  // Add stock status if selected
  if (inStock) {
    payload.instock = true;
  } else if (outOfStock) {
    payload.instock = false;
  }

  if (categories && categories.length > 0) {
    payload["categories"] = categories;
  }

  try {
    const response = await api.post(
      `/products-filter?page=1&status=1&limit=1000`,
      payload
    );

    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error filtering products:", error);
    return null;
  }
};
